import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";

export interface IPermission {
  code: string;
  value: any;
}

export interface IRoles {
  permissions: IPermission[];
}

export const parseRoles = (roles: IPermission[]) => {
  const permission: IPermission | any = {};
  roles?.forEach((role: IPermission) => {
    if (role.value === "true") {
      role.value = true;
    } else if (role.value === "false") {
      role.value = false;
    } else if (role.value && !isNaN(role?.value)) {
      role.value = Number(role.value);
    }
    permission[role.code] = role.value;
  });

  // Force cloud agent permissions to false
  permission["cloud_agent_permissions_new"] = false;
  permission["create_edit_agents_new"] = false;
  permission["view_agent_cloud_new"] = false;

  // making new_scan props forcefully true/false based on sub component props or new_scan_v2
  if (Object.keys(permission).length) {
    permission[ROLES_CONTENT_PROPS.NEW_SCAN] =
      permission["new_scan_v2"] !== undefined
        ? permission["new_scan_v2"]
        : (permission[ROLES_CONTENT_PROPS.UPLOAD_FILE] ||
           permission[ROLES_CONTENT_PROPS.SSH_CONNECTION] ||
           permission[ROLES_CONTENT_PROPS.API_CONNECTION]);

    // Aggregate Agent permissions
    permission[ROLES_CONTENT_PROPS.VIEW_AGENT] =
      permission["view_agent"] !== undefined
        ? permission["view_agent"]
        : (permission["view_agents"] ||
           permission["view_agent_new"] ||
           false);

    permission[ROLES_CONTENT_PROPS.CREATE_EDIT_AGENT] =
      permission["create_edit_agent"] !== undefined
        ? permission["create_edit_agent"]
        : (permission["create_edit_agents"] ||
           permission["create_edit_agent_new"] ||
           false);
  }
  return permission;
};

export interface ITypeData {
  label?: string;
  id?: string | number;
  data?: ITypeData[] | null;
  selected?: boolean;
  vendorName?: string;
  indeterminate?: boolean;
  parent?: ITypeData | null;
  lavel?: number
  name?: string;
  type?: string;
}
export const selectedFilterList = (data: ITypeData[]): ITypeData[] => {
  if (!Array.isArray(data)) {
    return data
  }
  return data.filter(item => {
    if (item?.data) {
      item.data = selectedFilterList(item.data);
      const allSelected = item.data.every(child => child.selected || (child.data && child.data.length > 0));
      const someSelected = item.data.some(child => child.selected || (child.data && child.data.length > 0));
      item.indeterminate = !allSelected && someSelected;
      return (item.data?.length ?? 0) > 0 || item.selected;
    }
    return item.selected;
  })
}
export const countSelectedCheckboxes = (data: ITypeData[]): number => {
  if (!Array.isArray(data)) {
    return 0;
  }
  return data.reduce((count, item) => {
    const isSelected = item.selected ? 1 : 0;
    const childCount = item.data ? countSelectedCheckboxes(item.data) : 0;
    return count + isSelected + childCount;
  }, 0);
};
export const createRegionFilterData = (regionFilter: ITypeData[] | any)=> {
  if (!Array.isArray(regionFilter)) {
    return regionFilter
  }
  return regionFilter.filter(item => {
    delete item.lavel;
    delete item.parent;
    if ('data' in item) {
      delete item.lavel;
      delete item.parent;
      item.data = createRegionFilterData(item.data || []);
    }
    return (item.selected || item.indeterminate)
  })
}
export const removeIndeterMinateProps = (filter: ITypeData[] | any)=> {
  filter.map((item: ITypeData) => {
    if (('data' in item)) {
      removeIndeterMinateProps(item.data || []);
    } else {
      item.vendorName = makeFirstLetterCapital(item.vendorName)
      delete item.indeterminate;
    }
  })
}
export const makeFirstLetterCapital = (str: string | undefined) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  } else {
      return '';
  }
}
export const clearData = (data: ITypeData[])=> {
  data?.forEach((obj, i) => {
    obj.selected = false;
    obj.indeterminate = false;
    clearData(obj.data || []);
  });
  return data;
}
export const getSelectedLastChildren = (node: ITypeData | any, result: any = [])=> {
  node?.forEach((item: any) => {
    if (item.data && item.data.length > 0) {
      getSelectedLastChildren(item.data, result);
    } else {
      if(item.selected) {
        result.push(item);
      }
    }
  });
  return result?.length || 0;
}